import React, {useCallback, useState} from 'react';
import Joi from 'joi';
import {CircularProgress, Typography} from '@material-ui/core';
import Section from 'components/forms/Section';
import {ImageSelect} from 'components/forms/fields';
import {defaultNext} from 'components/forms/context/FormNavigation';
import {isTouch} from 'utils/device';

const initialValues = {
    user_document_post_response: null,
};
const schema = {
    user_document_post_response: Joi.object({
        user_document: Joi.object().unknown(true),
        user_images: Joi.array().items(
            Joi.object({
                signed_url: Joi.string().required(),
                thumb_signed_url: Joi.string().required(),
            }).unknown(true)
        ),
    })
        .unknown(true)
        .required()
        .messages({
            'object.base': 'Please upload at least one document to continue',
        }),
};

const Upload = props => {
    const [uploader, setUploader] = useState({
        post: async () => true,
    });
    const [uploading, setUploading] = useState(false);

    const handleSetOnSubmit = useCallback(
        config => {
            setUploader(config);
        },
        [setUploader]
    );

    const deleteMessage = isTouch()
        ? 'To change a document, tap it and then the delete button that appears'
        : 'To change a document, hover over it and use the delete button that appears';

    return (
        <Section
            {...props}
            {...{schema, initialValues}}
            backButton={{
                disabled: true,
            }}
            nextButton={{
                disabled: uploading,
                icon: uploading ? CircularProgress : defaultNext.icon,
                label: uploading ? '' : defaultNext.label,
                beforeOnClick: async () => {
                    return uploader.post();
                },
            }}
        >
            <Typography variant='h6' align='left'>
                Please upload only ONE form at a time. If you have multiple forms,
                you will need to enter them separately.
            </Typography>
            <Typography variant='h6' align='left'>
                These documents will eventually be submitted to the USCG National
                Maritime Center
            </Typography>
            <Typography>
                <strong>
                    Please make sure that they are legible by using the source files
                    where possible.
                </strong>{' '}
                Avoid using mobile screenshots which are usually illegible.
            </Typography>
            <ImageSelect
                label='Upload Images'
                name='user_document_post_response'
                required
                documentType={props.documentType}
                setOnSubmit={handleSetOnSubmit}
                setUploading={setUploading}
            />
            <Typography>{deleteMessage}</Typography>
            {props.children}
        </Section>
    );
};

export default Upload;
